import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as config from "../../../config.json";
@Injectable()
export class UserService {

    constructor(private _http: HttpClient) {
    }
    hostUrl = config['serverUrl'];


    login(body: any) {
        return this._http.post(this.hostUrl + '/login', body, {
            observe: 'body',
            withCredentials: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        });
    }

    user() {
        return this._http.get(this.hostUrl + '/user', {
            observe: 'body',
            withCredentials: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        })
    }

    dynamicSort(property) {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property].toLowerCase() < b[property].toLowerCase()) ? -1 : (a[property].toLowerCase() > b[property].toLowerCase()) ? 1 : 0;
            return result * sortOrder;
        }
    }
    getUrl(){
        console.log(config['serverUrl'])
        return config['serverUrl']
    }

}


// WEBPACK FOOTER //
// ./src/app/core/user.service.ts